<template>
  <v-slide-x-reverse-transition>
    <v-card raised class="elevation-5 rulecollection-details vop-bg-whisper" v-if="isVisible">
      <div>
        <!-- Toolbar -->
        <v-toolbar flat color="vop-bg-whisper">
          <!-- Title -->
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span>{{ messages.label.RULE_COLLECTION }} - {{ selectedRuleCollection.title }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Test button -->
          <v-btn color="secondary" @click="showTestRuleModal()" small>
            {{ messages.label.TEST }}
          </v-btn>
          <!-- More Menu -->
          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn class="grey--text text--darken-2" v-on="on" small>
                {{ messages.label.ACTIONS }}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="goToEditView()">
                <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile class="error--text" @click="showDeleteDialog()">
                <v-list-tile-title>{{ messages.label.DELETE }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-toolbar-items>
            <!-- Close button -->
            <v-btn icon @click="hide()">
              <v-icon medium>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- Main Content -->
        <v-card-text>
          <v-progress-linear :indeterminate="true" height="4" v-if="ruleCollectionLoading">
          </v-progress-linear>
          <!-- Error Alert -->
          <v-flex xs12 v-if="errorAlert">
            <v-alert v-model="errorAlert" dismissible type="error">
              {{ errorMessage }}
            </v-alert>
          </v-flex>
          <v-tabs v-model="activeTab" color="vop-bg-whisper" slider-color="primary" @change="ensureWindow">
            <v-tab v-for="item in tabItems" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-layout wrap>
            <v-flex xs12>
              <v-tabs-items v-model="activeTab" ref="window">
                <v-tab-item>
                  <v-data-table :items="ruleCollectionDetails" hide-actions hide-headers class="mt-2">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left ttu" width="30%">{{ props.item.name }}</td>
                      <td class="text-xs-left">
                        <!-- Inline Title Edit -->
                        <template v-if="props.item.name === 'title'">
                          <div>
                            <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                              @save="saveField(props.item.value, 'title')" @cancel="cancelInlineEdit">
                              <!-- Title Display -->
                              <div v-if="!$lodash.isEmpty(props.item.value)">
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                              </div>
                              <div v-else>
                                {{ messages.label.ADD_TITLE }}
                                <v-icon small class="ml-2" color="primary">add_circle</v-icon>
                              </div>
                              <!-- Title Edit Input -->
                              <template v-slot:input>
                                <div class="mt-3 subtitle ttu" v-if="!$lodash.isEmpty(props.item.value)">
                                  {{ messages.label.UPDATE_TITLE }}
                                </div>
                                <div class="mt-3 subtitle ttu" v-else>{{ messages.label.ADD_TITLE }}
                                </div>
                                <v-text-field v-model="props.item.value" clearable
                                  v-validate="{ required: true, max:100, regex: /^[0-9a-zA-Z\s\/_-]*$/i }"
                                  :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
                                  :label="messages.label.RULE_TITLE" single-line autofocus>
                                </v-text-field>
                              </template>
                            </v-edit-dialog>
                          </div>
                        </template>
                        <!-- Inline Description Edit -->
                        <template v-else-if="props.item.name === 'description'">
                          <div>
                            <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                              @save="saveField(props.item.value, 'description')" @cancel="cancelInlineEdit">
                              <!-- Description Display -->
                              <div v-if="!$lodash.isEmpty(props.item.value) && !$lodash.isNull(props.item.value)">
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                              </div>
                              <div v-else>
                                {{ messages.label.ADD_DESCRIPTION }}
                                <v-icon small class="ml-2" color="primary">add_circle</v-icon>
                              </div>
                              <!-- Description Edit Input -->
                              <template v-slot:input>
                                <div class="mt-3 subtitle ttu" v-if="!$lodash.isEmpty(props.item.value)">
                                  {{ messages.label.UPDATE_DESCRIPTION }}
                                </div>
                                <div class="mt-3 subtitle ttu" v-else>{{ messages.label.ADD_DESCRIPTION }}
                                </div>
                                <v-textarea v-model="props.item.value" clearable v-validate="'max:500'"
                                  :error-messages="errors.collect('description')" data-vv-name="description"
                                  :counter="500" :label="messages.label.RULE_DESCRIPTION" single-line autofocus>
                                </v-textarea>
                              </template>
                            </v-edit-dialog>
                          </div>
                        </template>
                        <!-- Inline Enabled status edit -->
                        <template v-else-if="props.item.name === 'enabled'">
                          <div>
                            <div>
                              <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                                @save="saveField(props.item.value, 'enabled')" @cancel="cancelInlineEdit">
                                <!-- Enabled Status Display -->
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                                <!-- Description Edit Input -->
                                <template v-slot:input>
                                  <div class="mt-3 subtitle ttu">
                                    {{ messages.label.UPDATE_ENABLED }}
                                  </div>
                                  <v-switch v-model="props.item.value" class="mt-0" hide-details color="primary"
                                    :label="`${(props.item.value).toString()}`">
                                  </v-switch>
                                </template>
                              </v-edit-dialog>
                            </div>
                          </div>
                        </template>
                        <template v-else-if="props.item.name === 'updated'">
                          {{ props.item.value ? props.item.value : "---" }}
                          {{getUserIdString('updatedByUserId')}}
                        </template>
                        <template v-else-if="props.item.name === 'added'">
                          {{ props.item.value }} {{getUserIdString('addedByUserId')}}
                        </template>
                        <template v-else>
                          <div>
                            {{ props.item.value }}
                          </div>
                        </template>
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <!-- Rule Sets -->
                <v-tab-item>
                  <v-data-table :headers="ruleSetHeaders" :items="ruleSets" class="mt-1" ref="draggableTable">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="handle" style="max-width: 28px" v-if="displayDragHandle">
                          <v-icon>drag_handle</v-icon>
                        </td>
                        <td class="text-xs-left" width="35%">
                          <v-btn flat icon color="primary" @click="props.expanded = !props.expanded">
                            <v-icon>{{ props.expanded ? 'remove_circle' : 'add_circle' }}</v-icon>
                          </v-btn>
                          {{ props.item.title }}
                        </td>
                        <td class="text-xs-right" width="12%">Rule Set</td>
                        <td class="text-xs-right" width="12%">{{ !props.item.disabled }}</td>
                        <td class="text-xs-center" width="12%" v-if="displayDragHandle">{{ props.item.sequence + 1 }}
                        </td>
                        <td @click.stop="stopProp" class="text-xs-right">
                          <v-menu bottom left>
                            <v-btn icon slot="activator">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>
                              <v-list-tile @click="openRuleSetQuickView(props.item)">
                                <v-list-tile-title>{{ messages.label.VIEW_DETAILS }}</v-list-tile-title>
                                <v-icon small right>
                                  open_in_new
                                </v-icon>
                              </v-list-tile>
                              <!-- <v-list-tile>
                                <v-list-tile-title>{{ messages.label.COPY_TO }}</v-list-tile-title>
                              </v-list-tile> -->
                              <v-list-tile @click="goToEditRuleSetView(props.item)">
                                <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </td>
                      </tr>
                    </template>
                    <!-- Expanded view-->
                    <template slot="expand" slot-scope="props">
                      <v-data-table hide-actions hide-headers :items="props.item.items">
                        <template slot="items" slot-scope="props">
                          <!-- <tr class="indigo lighten-5 ml-3 expandableRows"> -->
                          <!-- Place empty column for the alignment with sequence -->
                          <td class="handle" style="max-width: 28px" v-if="displayDragHandle"></td>
                          <td class="text-xs-left" width="35%">
                            <!-- Place holder button to fix the alignment -->
                            <v-btn flat disabled icon color="primary">
                              <v-icon small>trip_origin</v-icon>
                            </v-btn>
                            {{ props.item.title }}
                          </td>
                          <td class="text-xs-left" width="12%">Rule</td>
                          <td class="text-xs-left" width="12%">{{ !props.item.disabled }}</td>
                          <td @click.stop="stopProp" class="text-xs-right">
                            <v-menu bottom left>
                              <v-btn icon slot="activator">
                                <v-icon>more_vert</v-icon>
                              </v-btn>
                              <v-list>
                                <v-list-tile @click="openRuleQuickView(props.item)">
                                  <v-list-tile-title>{{ messages.label.VIEW_DETAILS }}</v-list-tile-title>
                                  <v-icon small right>
                                    open_in_new
                                  </v-icon>
                                </v-list-tile>
                                <!-- <v-list-tile>
                                  <v-list-tile-title>{{ messages.label.COPY_TO }}</v-list-tile-title>
                                </v-list-tile> -->
                                <v-list-tile @click="goToEditRuleView(props.item)">
                                  <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </td>
                          <!-- </tr> -->
                        </template>
                        <template slot="no-data">
                          <v-alert :value="true" color="info" class="black--text" icon="info">
                            {{ messages.info.NO_RULES }}
                          </v-alert>
                        </template>
                      </v-data-table>
                    </template>
                    <!-- No Data -->
                    <template slot="no-data">
                      <v-alert :value="true" color="info" class="black--text" icon="info">
                        {{ messages.info.NO_RULE_SETS }}
                      </v-alert>
                    </template>
                    <!-- No Results -->
                    <template slot="no-results">
                      <v-alert :value="true" color="info" class="black--text" icon="info">
                        {{ messages.info.NO_FILTER_RESULTS }}
                      </v-alert>
                    </template>
                  </v-data-table>
                  <v-btn color="primary" v-if="displayUpdateRuleSetsSequenceButton" :disabled="updatingRuleCollection"
                    :loading="updatingRuleCollection" @click="updateRuleSetsSequence">
                    {{ messages.label.SAVE }}
                  </v-btn>
                </v-tab-item>
                <v-tab-item>
                  <JSONView :json="selectedRuleCollectionJSON" />
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <!-- Delete Dialog -->
        <v-dialog v-model="deleteDialog" width="500">
          <v-card>
            <v-card-title class="subheading ttu">
              {{ messages.label.DELETE }}
            </v-card-title>
            <v-card-text>
              <!-- Error Alert -->
              <v-flex xs12 v-if="deleteErrorAlert">
                <v-alert v-model="deleteErrorAlert" type="error">
                  {{ deleteErrorMessage }}
                </v-alert>
              </v-flex>
              <p>{{ messages.info.DELETE_RULE_1 }} <b>{{ selectedRuleCollection.title }}</b> ? </p>
              <p v-html="messages.info.DELETE_RULE_2"></p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-1 white--text" @click="cancelDelete">
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" :disabled="deletingRule" :loading="deletingRule" @click="deleteRule()">
                {{ messages.label.YES }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
      <!-- Rule Test Dialog -->
      <XVATRuleTest v-model="ruleTestDialog" :rule-obj="ruleObjectToTest" :rule-category="'ruleCollection'" />
      <!-- Rule Copy Dialog -->
      <XVATRuleCopy v-model="ruleCopyDialog" :rule-obj="ruleObjectToCopy" />
      <!-- Rule Override Dialog -->
      <XVATRuleOverride v-model="ruleOverrideDialog" :rule-obj="ruleObjectToOverride" />
      <!-- Snackbar -->
      <v-flex xs12>
        <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
          {{ snackbar.message }}
          <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
        </v-snackbar>
      </v-flex>
      <!-- Dialogs -->
      <v-dialog v-model="ruleQuickViewDialog" width="1000" height="800">
        <RuleQuickView />
      </v-dialog>
      <v-dialog v-model="ruleSetQuickViewDialog" width="1000" height="800">
        <RuleSetQuickView />
      </v-dialog>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapState } from "vuex"
import XVATRulesService from "@/XVAT/XVATRulesService"
import * as xvatDataService from "@/XVAT/XVATDataService"
import * as utils from "@/Shared/utils"
import messages from "@/XVAT/messages.json"
import JSONView from "@/XVAT/JSONView"
import XVATRuleTest from "@/XVAT/XVATRuleTest"
import RuleQuickView from "@/XVAT/Rule/RuleQuickView"
import RuleSetQuickView from "@/XVAT/RuleSet/RuleSetQuickView"
import XVATRuleCopy from "@/XVAT/XVATRuleCopy"
import XVATRuleOverride from "@/XVAT/XVATRuleOverride"
import Sortable from "sortablejs"

export default {
  name: "RuleCollectionQuickView",
  $_veeValidate: {
    validator: "new"
  },
  components: {
    RuleQuickView,
    RuleSetQuickView,
    JSONView,
    XVATRuleTest,
    XVATRuleCopy,
    XVATRuleOverride
  },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: 3000,
        color: "error",
        message: ""
      },
      activeTab: null,
      ruleObjectToTest: {},
      ruleObjectToCopy: {},
      ruleObjectToOverride: {},
      ruleTestDialog: false,
      ruleCopyDialog: false,
      ruleOverrideDialog: false,
      tabItems: ["DETAILS", "RULE SETS", "{JSON}"],
      selectedRuleCollection: {},
      selectedRuleCollectionJSON: {},
      selectedRuleCollectionOriginal: {},
      isVisible: false,
      ruleSets: [],
      originalRuleSets: [],
      rules: [],
      ruleCollectionDetails: [],
      errorAlert: false,
      errorMessage: "",
      ruleCollectionLoading: false,
      expand: true,
      deleteDialog: false,
      deletingRule: false,
      deleteErrorAlert: false,
      deleteErrorMessage: "",
      ruleQuickViewDialog: false,
      ruleSetQuickViewDialog: false,
      updatingRuleCollection: false,
      dictionary: this.getValidationDictionary()
    }
  },
  computed: {
    ruleSetHeaders() {
      return this.getRuleSetHeaders()
    },
    /**
     * displayDragHandle  - identify if sequence handle needs to be displayed
     * @returns {boolean}
     */
    displayDragHandle() {
      let display = false
      if (!this.$lodash.isUndefined(this.selectedRuleCollection) &&
        this.selectedRuleCollection.type === "TRANSFORMATION") {
        display = true
        this.$nextTick(() => {
          let table = this.$refs.draggableTable.$el.getElementsByTagName("tbody")[0]
          const _self = this
          Sortable.create(table, {
            handle: ".handle", // Use handle so user can select text
            onEnd({ newIndex, oldIndex }) {
              oldIndex = oldIndex / 2
              newIndex = newIndex / 2
              let rowSelected = _self.ruleSets.splice(oldIndex, 1)[0] // Get the selected row and remove it
              _self.ruleSets.splice(newIndex, 0, rowSelected) // Move it to the new index
              _self.resetRuleSetsSequenceNumbers()
              _self.sortRuleSetsOnSequence()
            }
          })
        })
      }
      return display
    },
    /**
     * displayUpdateRuleSetsSequenceButton  - identify if user has changed the sequence of ruleSets within rulecollection
     * @returns {boolean}
     */
    displayUpdateRuleSetsSequenceButton() {
      let display = false
      let ruleSetsArray = []
      if (this.ruleSets.length > 0) {
        this.$lodash.forEach(this.ruleSets, (object, index) => {
          // Remove sequence field before comparing
          object = this.$lodash.omit(object, ["sequence"])
          ruleSetsArray[index] = object
        })
      }
      if (JSON.stringify(ruleSetsArray) !== JSON.stringify(this.originalRuleSets)) {
        display = true
      }
      return display
    }
  },
  methods: {
    /**
    * show - Show ruleset details view
    * @param {object} selectedRuleCollection
    */
    show(selectedRuleCollection) {
      this.resetData()
      this.selectedRuleCollection = selectedRuleCollection
      this.selectedRuleCollectionJSON = {}
      this.selectedRuleCollectionOriginal = this.$lodash.cloneDeep(this.selectedRuleCollection)
      this.constructRuleCollectionDetails()
      this.displayRuleCollectionRuleSets()
      this.$nextTick(() => {
        this.constructJSONViewObject()
      })
      // TODO : Ideally we would want to leave tab selection as is when the user is switching
      // between rows, due to the tab update issues, we are defaulting to showing first tab
      this.isVisible = true
      this.activeTab = 0
    },

    /**
    * resetData - Reset data
    */
    resetData() {
      this.errorAlert = false
      this.errorMessage = ""
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters",
            regex: "Valid characters are : A-Z a-z 0-9 / _ -"
          },
          description: {
            max: "Description may not be greater than 100 characters"
          }
        }
      }
    },

    /**
     * getRuleSetHeaders - Construct array of objects to show table headers
     * @return {array}
     */
    getRuleSetHeaders() {
      let headerToDisplay = []
      if (this.displayDragHandle) {
        headerToDisplay = [{
          text: "",
          align: "left",
          sortable: false
        },
        {
          text: messages.label.TH_TITLE,
          sortable: true,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_TYPE,
          sortable: false,
          align: "left"
        },
        {
          text: messages.label.TH_ENABLED,
          sortable: false,
          align: "left",
          value: "enabled"
        },
        {
          text: "SEQUENCE",
          align: "center",
          value: "sequence",
          sortable: true
        },
        {
          text: "",
          sortable: false
        }]
      } else {
        headerToDisplay = [
        {
          text: messages.label.TH_TITLE,
          sortable: true,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_TYPE,
          sortable: false,
          align: "left"
        },
        {
          text: messages.label.TH_ENABLED,
          sortable: false,
          align: "left",
          value: "enabled"
        },
        {
          text: "",
          sortable: false
        }]
      }

      return headerToDisplay
    },

    /**
    * Retrieve user Id from rule details array
    * @param {*} ruleDetails
    * @param {*} key
    */
    getUserIdString(key) {
      let userString = ""
      let userId = ""
      let value = this.selectedRuleCollection[key]
      if (value && value !== null) {
        userId = value
        userString = "[ User: " + userId + " ]"
      }
      return userString
    },

    /**
     * constructRuleCollectionDetails - Construct selected rule details
     * This is being done to display in a data table
     */
    constructRuleCollectionDetails() {
      this.ruleCollectionDetails = []

      let requiredFields = ["title", "type", "description", "_enabled", "_added", "_updated"]
      requiredFields.forEach((fieldName) => {
        let obj = {}
        if (this.selectedRuleCollection.hasOwnProperty(fieldName)) {
          obj["name"] = fieldName.charAt(0) === "_" ? fieldName.substring(1) : fieldName

          if (fieldName === "description") {
            obj["value"] = decodeURI(this.selectedRuleCollection[fieldName])
          } else {
            obj["value"] = this.selectedRuleCollection[fieldName]
          }

          this.ruleCollectionDetails.push(obj)
        }
      })
    },

    /**
    * constructJSONViewObject
    */
    constructJSONViewObject() {
      let jsonViewObj = this.$lodash.cloneDeep(this.selectedRuleCollectionOriginal)
      jsonViewObj = this.$lodash.omit(jsonViewObj, [
        "_added",
        "_enabled",
        "_updated"
      ])
      // Ensure we are not displaying encoded string in JSON view
      jsonViewObj["description"] = decodeURI(jsonViewObj["description"])
      this.selectedRuleCollectionJSON = jsonViewObj
    },

    /**
    * Update data todisplay rule set rules
    */
    displayRuleCollectionRuleSets() {
      if (this.selectedRuleCollection.items && this.selectedRuleCollection.items.length > 0) {
        this.ruleSets = XVATRulesService.addClientOnlyFields(this.selectedRuleCollection.items)
        // Add client side fields for rule objects
          this.$lodash.forEach(this.ruleSets, (ruleSet) => {
            if (ruleSet.items.length > 0) {
              ruleSet.items = XVATRulesService.addClientOnlyFields(ruleSet.items)
            }
          })
        this.originalRuleSets = this.$lodash.cloneDeep(this.ruleSets)
        this.resetRuleSetsSequenceNumbers()
      } else {
        this.ruleSets = []
      }
    },

    /**
     * Reset / update sequence numbers for ruleSets within rule collection
     */
    resetRuleSetsSequenceNumbers() {
      if (this.ruleSets.length > 0) {
        this.$lodash.forEach(this.ruleSets, (ruleSet, index) => {
          ruleSet["sequence"] = index
        })
      }
    },

    /**
     * Sort ruleSets within rule collection based on sequence number
     */
    sortRuleSetsOnSequence() {
      if (this.ruleSets.length > 0) {
        let sortedList = this.$lodash.sortBy(this.ruleSets, "sequence")
        this.ruleSets = []
        this.$nextTick(() => {
          this.ruleSets = sortedList
        })
      }
    },



    /**
    * saveTitle - Save changes made to title
    * @param {string} value
    */
    saveField(value, fieldName) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let ruleCollectionObjToUpdate = this.$lodash.cloneDeep(this.selectedRuleCollectionOriginal)
          let valueChanged = false
          if (fieldName === "enabled") {
            ruleCollectionObjToUpdate.disabled = !value
            valueChanged = !(ruleCollectionObjToUpdate.disabled === this.selectedRuleCollectionOriginal.disabled)
          } else {
            value = this.$lodash.isNull(value) ? "" : value
            ruleCollectionObjToUpdate[fieldName] = value
            valueChanged = !(ruleCollectionObjToUpdate[fieldName] === this.selectedRuleCollectionOriginal[fieldName])
          }
          // Update only when the value has changed
          if (valueChanged) {
            ruleCollectionObjToUpdate = XVATRulesService.omitClientOnlyFields(ruleCollectionObjToUpdate)
            //Note : Special treatment as input requires the collection to be named as 'inputItems'
            ruleCollectionObjToUpdate["inputItems"] = this.getRuleCollectionRuleSetIds(ruleCollectionObjToUpdate.items)
            ruleCollectionObjToUpdate = this.$lodash.omit(ruleCollectionObjToUpdate, ["items"])
            this.updateRuleCollection(ruleCollectionObjToUpdate)
          }
        } else {
          // Clickingon "clearable" icon sets the value to null
          let fieldObjIndex = this.$lodash.findIndex(this.ruleCollectionDetails, { "name": fieldName })
          // Revert to original value
          let originalObj = {
            name: fieldName,
            value: this.selectedRuleCollectionOriginal[fieldName]
          }
          // NOTE: This might seem tricky but, this code is trying to addresss the reactivity issues related to vue
          // when dealing with arrays. We are assigning a new array instead of modifying the array
          let ruleCollectionDetailsCopy = this.$lodash.cloneDeep(this.ruleCollectionDetails)
          this.ruleCollectionDetails = [] // to help with reactivity issue
          ruleCollectionDetailsCopy.splice(fieldObjIndex, 1, originalObj)
          this.$nextTick(() => {
            this.ruleCollectionDetails = ruleCollectionDetailsCopy
          })
        }
      })
    },

    /**
     *updateRuleSetsSequence-Update Rules Sequence within ruleSet
     */
    updateRuleSetsSequence() {
      this.updatingRuleCollection = true
      let ruleCollectionObjToUpdate = this.$lodash.cloneDeep(this.selectedRuleCollectionOriginal)
      ruleCollectionObjToUpdate["inputItems"] = this.getRuleCollectionRuleSetIds(this.ruleSets)
      ruleCollectionObjToUpdate = XVATRulesService.omitClientOnlyFields(ruleCollectionObjToUpdate)
      //Remove 'items' as we are replacing it with 'inputItems'
      ruleCollectionObjToUpdate = this.$lodash.omit(ruleCollectionObjToUpdate, ["items"])

      this.updateRuleCollection(ruleCollectionObjToUpdate)
    },

    /**
     * Cancels inline editing and resets the validation
     */
    cancelInlineEdit() {
      this.$validator.reset()
    },

    /**
     * getRuleCollectionRuleSetIds - Retrieves just the rule ids required for create / update
     */
    getRuleCollectionRuleSetIds(ruleCollectionRuleSetArray) {
      if (ruleCollectionRuleSetArray.length > 0) {
        return this.$lodash.map(ruleCollectionRuleSetArray, "id")
      } else {
        return []
      }
    },

    /**
     * updateRuleCollection - update the rule set
     * @param {object} ruleCollectionObj
     */
    updateRuleCollection(ruleCollectionObj) {
      this.updatingRuleCollection = true
      // Encode Description
      ruleCollectionObj.description = encodeURI(decodeURI(ruleCollectionObj.description))

      xvatDataService.updateRuleCollection(ruleCollectionObj.id,
        ruleCollectionObj)
        .then(() => {
          this.resetData()
          // Show snack bar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.RULE_COLLECTION_UPDATED
          XVATRulesService.$emit("event:refreshRulesList")
        })
        .catch((error) => {
          let response = error.response.data
          if (response.isException) {
            this.errorAlert = true
            this.errorMessage = response.description
            // Re-populate original data
            this.constructRuleCollectionDetails()
            this.displayRuleCollectionRuleSets()
            this.constructJSONViewObject()
          }
        })
        .finally(() => {
          this.updatingRuleCollection = false
        })
    },
    /**
     * hide - Hide the quick view
     */
    hide() {
      XVATRulesService.$emit("event:hideRuleQuickView")
      this.resetData()
      this.isVisible = false
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { },

    /**
     * goToEditView - Navigate to Edit view
     */
    goToEditView() {
      let id = this.selectedRuleCollection.id
      this.$router.push({
        name: "XVATManageRuleCollection",
        params: { id: id }
      })
    },

    /**
     * goToEditView - Navigate to Edit view
     * @param {object} ruleSet
     */
    goToEditRuleSetView(ruleSet) {
      let id = ruleSet.id
      this.$router.push({
        name: "XVATManageRuleSet",
        params: { id: id }
      })
    },

    /**
     * goToRuleEditView - Navigate to Edit view
     * @param {object} rule
     */
    goToEditRuleView(rule) {
      let id = rule.id
      this.$router.push({
        name: "XVATManageRule",
        params: { id: id }
      })
    },

    /**
     * showDeleteDialog -
     */
    showDeleteDialog() {
      this.deleteDialog = true
    },

    /**
     * cancelDelete - close delete dialog
     */
    cancelDelete() {
      this.deleteErrorAlert = false
      this.deleteErrorMessage = ""
      this.deleteDialog = false
    },

    /**
     * deleteRule - Delete selected rule / ruleset / rule collection
     */
    deleteRule() {
      this.deletingRule = true
      let ruleCollectionId = this.selectedRuleCollection.id
      xvatDataService
        .deleteRuleCollection(ruleCollectionId,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then(() => {
          this.deleteDialog = false
          // Show Snackbar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.DELETE_SUCCESS + this.selectedRuleCollection.title
          XVATRulesService.$emit("event:refreshRulesList")
        }).catch((error) => {
          let isServerError = utils.isMPXError(error)
          if (isServerError) {
            this.deleteErrorAlert = true
            this.deleteErrorMessage = error.response.data.description
          }
        })
        .finally(() => {
          this.deletingRule = false
        })
    },

    /**
     * openRuleQuickView - Open rule quick view in dialog
     */
    openRuleQuickView(ruleObj) {
      this.ruleQuickViewDialog = true
      XVATRulesService.$emit("event:showRuleQuickViewDialog", ruleObj)
    },

    /**
     * closeRuleQuickView - close the dialog view of rule quick view
     */
    closeRuleQuickView() {
      this.ruleQuickViewDialog = false
    },

    /**
     * openRuleSetQuickView - Open ruleset quick view in dialog
     */
    openRuleSetQuickView(ruleSetObj) {
      this.ruleSetQuickViewDialog = true
      XVATRulesService.$emit("event:showRuleSetQuickViewDialog", ruleSetObj)
    },

    /**
     * closeRuleSetQuickView - close the dialog view of rule set quick view
     */
    closeRuleSetQuickView() {
      this.ruleSetQuickViewDialog = false
    },

    /**
     * showTestRuleModal
     */
    showTestRuleModal() {
      this.ruleObjectToTest = this.selectedRuleCollection
      this.ruleTestDialog = true
    },

    /**
     * showCopyRuleModal
     */
    showCopyRuleModal() {
      this.ruleObjectToCopy = this.selectedRuleCollectionOriginal
      this.ruleCopyDialog = true
    },

    /**
     * showOverrideRuleModal
     */
    showOverrideRuleModal() {
      this.ruleObjectToOverride = this.selectedRuleCollectionOriginal
      this.ruleOverrideDialog = true
    },

    /**
      * NOTE: Fix for auto height adjust issue of v-tabs
      * FIXME: Once fix is available, update vuetify version
      */
    ensureWindow() {
      clearTimeout(this.windowTimeout)
      this.windowTimeout = setTimeout(() => {
        this.$refs.window.internalHeight = null
        this.$refs.window.isActive = false
      }, 1000)
    }
  },
  filters: {
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
    XVATRulesService.$on("event:showRuleCollectionQuickView", this.show)
    XVATRulesService.$on("event:hideRuleQuickViewDialog", this.closeRuleQuickView)
    XVATRulesService.$on("event:hideRuleSetQuickViewDialog", this.closeRuleSetQuickView)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:showRuleCollectionQuickView", this.show)
    XVATRulesService.$off("event:hideRuleQuickViewDialog", this.closeRuleQuickView)
    XVATRulesService.$off("event:hideRuleSetQuickViewDialog", this.closeRuleSetQuickView)
  }
}
</script>

<style lang="scss" scoped>
.rule-details {
  min-height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/RuleCollection/RuleCollectionQuickView.vue